export const DEFAULT_POLL_INTERVAL_SECONDS = 60
